// extracted by mini-css-extract-plugin
export default {"content":"LoginRequiredModal_content__4HkN6","dialogText":"LoginRequiredModal_dialogText__dlNiE","buttons":"LoginRequiredModal_buttons__c7URc"};